module.exports = __webpack_public_path__ + "static/img/logo_32x32.479fbb94.svg";